import { USER_ROLES } from "@nlc/shared-types";

export const userRoles = [
  { id: 1, name: USER_ROLES.SUPER_ADMIN },
  { id: 2, name: USER_ROLES.OWNER },
  { id: 3, name: USER_ROLES.ADMIN },
  { id: 4, name: USER_ROLES.COLLABORATOR },
  { id: 5, name: USER_ROLES.ASANA_USER },
  { id: 6, name: USER_ROLES.TEAM_LEADER },
  { id: 7, name: USER_ROLES.DESIGNER },
  { id: 8, name: USER_ROLES.CUSTOMER_SUCCESS },
  { id: 9, name: USER_ROLES.SUPPORT },
  { id: 10, name: USER_ROLES.ACCOUNT_SUPPORT },
  { id: 11, name: USER_ROLES.ORGANIZATION_ADMIN },
];

export type UserRole = (typeof userRoles)[number]["name"];

const customers: UserRole[] = [
  USER_ROLES.OWNER,
  USER_ROLES.ADMIN,
  USER_ROLES.COLLABORATOR,
];
const teamMembers: UserRole[] = [
  USER_ROLES.SUPER_ADMIN,
  USER_ROLES.TEAM_LEADER,
  USER_ROLES.DESIGNER,
  USER_ROLES.CUSTOMER_SUCCESS,
];
const managers: UserRole[] = [
  USER_ROLES.SUPER_ADMIN,
  USER_ROLES.TEAM_LEADER,
  USER_ROLES.OWNER,
  USER_ROLES.ADMIN,
  USER_ROLES.CUSTOMER_SUCCESS,
];
const leaders: UserRole[] = [USER_ROLES.TEAM_LEADER, USER_ROLES.SUPER_ADMIN];
const internalManagers: UserRole[] = [
  USER_ROLES.SUPER_ADMIN,
  USER_ROLES.CUSTOMER_SUCCESS,
  USER_ROLES.TEAM_LEADER,
];

function createFeatureRoleMap<T extends Record<string, UserRole[]>>(map: T): T {
  return map;
}

export const featureRoleMap = createFeatureRoleMap({
  "brand.new-badge.view": [...teamMembers],
  "brands.notes.edit": [
    ...customers,
    ...teamMembers,
    USER_ROLES.SUPPORT,
    USER_ROLES.ACCOUNT_SUPPORT,
    USER_ROLES.ORGANIZATION_ADMIN,
  ],
  "chat.comment.delete": [...leaders],
  "confidence-checker.admin": [USER_ROLES.SUPER_ADMIN],
  "create-brand": [...managers],
  "create-brand-button": [USER_ROLES.OWNER, USER_ROLES.ADMIN],
  "edit-request.assignee.edit": [...internalManagers],
  "edit-request.assignee.view": [...customers, USER_ROLES.DESIGNER],
  "edit-request.brand-section": [...teamMembers],
  "edit-request.brand.edit": [...internalManagers, ...customers],
  "edit-request.brand.view": [USER_ROLES.DESIGNER],
  "edit-request.complete": [...customers, ...internalManagers],
  "edit-request.complexity.edit": [...internalManagers],
  "edit-request.complexity.view": [USER_ROLES.DESIGNER],
  "edit-request.created-by.edit": [...internalManagers],
  "edit-request.created-by.view": [...teamMembers],
  "edit-request.details.customer.view": [...customers],
  "edit-request.details.designer.view": [USER_ROLES.DESIGNER],
  "edit-request.details.team.view": [...internalManagers],
  "edit-request.due.edit": [...teamMembers],
  "edit-request.internal-due": [...teamMembers],
  "edit-request.kebab-menu": [
    ...customers,
    USER_ROLES.SUPER_ADMIN,
    USER_ROLES.TEAM_LEADER,
    USER_ROLES.CUSTOMER_SUCCESS,
  ],
  "edit-request.kebab-menu.archive": [...customers, ...teamMembers],
  "edit-request.kebab-menu.change-account": [...internalManagers],
  "edit-request.kebab-menu.delete": [...teamMembers],
  "edit-request.kebab-menu.having-problem": [...customers],
  "edit-request.pause": [...customers],
  "edit-request.status.edit": [...teamMembers],
  "edit-request.title.edit": [...leaders, ...customers],
  "edit-request.upload-file": [...teamMembers],
  "internal-notes.edit": [...internalManagers],
  "my-files.files.delete": [...teamMembers],
  "my-files.files.upload": [...leaders, USER_ROLES.DESIGNER],
  "my-files.gdrive-sync.view": [USER_ROLES.OWNER],
  "my-files.trash.view": [...leaders],
  "request.rating.edit": [...leaders],
});

export type FeatureKey = keyof typeof featureRoleMap;
